<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计划名称：</span>
        </div>
        <el-input v-model="planName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">计划时段：</span>
        </div>
        <time-interval :defaultLineIndex="defaultLineIndex" @getAttendanceItemDurations="getAttendanceItemDurations" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {api} from '../../api/LadderControl'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../utils/notice'
  import {pattern} from '../../../utils/regular'
  import TimeInterval from '../../../components/WeekTime/timeInterval'

  export default {
    components: {
      TimeInterval,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'ladder-plant-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧梯控',
          name: 'ladder-device'
        }, {
          value: '设备管理',
        }],
        mainTitle: '修改计划',
        subheading: '',

        code: '',
        planName: '',
        monDetails: [],
        tueDetails: [],
        wedDetails: [],
        thuDetails: [],
        friDetails: [],
        satDetails: [],
        sunDetails: [],

        defaultLineIndex: []
      }
    },
    created () {
      this.getLiftPlanByCode(this.$route.params.id)
    },
    methods: {
      // 获取详细数据
      getLiftPlanByCode (id) {
        api.getLiftPlanByCode(id)
          .then(data => {
            this.code = data.code
            this.planName = data.planName
            this.monDetails = data.monDetails
            this.tueDetails = data.tueDetails
            this.wedDetails = data.wedDetails
            this.thuDetails = data.thuDetails
            this.friDetails = data.friDetails
            this.satDetails = data.satDetails
            this.sunDetails = data.sunDetails


            data.attendanceItemDurations = [
              {
                segments: data.monDetails,
                weekType: '1'
              }, {
                segments: data.tueDetails,
                weekType: '2'
              }, {
                segments: data.wedDetails,
                weekType: '3'
              }, {
                segments: data.thuDetails,
                weekType: '4'
              }, {
                segments: data.friDetails,
                weekType: '5'
              }, {
                segments: data.satDetails,
                weekType: '6'
              }, {
                segments: data.sunDetails,
                weekType: '7'
              }
            ]

            let timePlanArr = []
            for (let h = 0; h < data.attendanceItemDurations.length; h++) {
              let obj = {
                weekDay: [],
                week: [
                  {
                    key: '周一',
                    disabled: false
                  },
                  {
                    key: '周二',
                    disabled: false
                  },
                  {
                    key: '周三',
                    disabled: false
                  },
                  {
                    key: '周四',
                    disabled: false
                  },
                  {
                    key: '周五',
                    disabled: false
                  },
                  {
                    key: '周六',
                    disabled: false
                  },
                  {
                    key: '周日',
                    disabled: false
                  }
                ],
                weekTimeValue: [],
              }
              for (let k = 0; k < data.attendanceItemDurations.length; k++) {
                if (data.attendanceItemDurations[h].segments.length > 0) {
                  data.attendanceItemDurations[h].segments.map(hv => {
                    data.attendanceItemDurations[k].segments.map(kv => {
                      if (`${hv.startTime}${hv.endTime}` === `${kv.startTime}${kv.endTime}`) {
                        if (data.attendanceItemDurations[h].weekType === '1' || data.attendanceItemDurations[k].weekType === '1') {
                          if (obj.weekDay.indexOf('周一') === -1) {
                            obj.weekDay.push('周一')
                          }
                        }
                        if (data.attendanceItemDurations[h].weekType === '2' || data.attendanceItemDurations[k].weekType === '2') {
                          if (obj.weekDay.indexOf('周二') === -1) {
                            obj.weekDay.push('周二')
                          }
                        }
                        if (data.attendanceItemDurations[h].weekType === '3' || data.attendanceItemDurations[k].weekType === '3') {
                          if (obj.weekDay.indexOf('周三') === -1) {
                            obj.weekDay.push('周三')
                          }
                        }
                        if (data.attendanceItemDurations[h].weekType === '4' || data.attendanceItemDurations[k].weekType === '4') {
                          if (obj.weekDay.indexOf('周四') === -1) {
                            obj.weekDay.push('周四')
                          }
                        }
                        if (data.attendanceItemDurations[h].weekType === '5' || data.attendanceItemDurations[k].weekType === '5') {
                          if (obj.weekDay.indexOf('周五') === -1) {
                            obj.weekDay.push('周五')
                          }
                        }
                        if (data.attendanceItemDurations[h].weekType === '6' || data.attendanceItemDurations[k].weekType === '6') {
                          if (obj.weekDay.indexOf('周六') === -1) {
                            obj.weekDay.push('周六')
                          }
                        }
                        if (data.attendanceItemDurations[h].weekType === '7' || data.attendanceItemDurations[k].weekType === '7') {
                          if (obj.weekDay.indexOf('周日') === -1) {
                            obj.weekDay.push('周日')
                          }
                        }
                        if (obj.weekTimeValue.length === 0) {
                          let timeValueObj = {
                            key: [hv.startTime, hv.endTime]
                          }
                          obj.weekTimeValue.push(timeValueObj)
                        } else {
                          let oldWeekTimeValue = []
                          obj.weekTimeValue.map(weekTimeValue => {
                            oldWeekTimeValue.push(`${weekTimeValue.key[0]}${weekTimeValue.key[1]}`)
                          })
                          if (oldWeekTimeValue.indexOf(`${hv.startTime}${hv.endTime}`) === -1) {
                            obj.weekTimeValue.push({
                              key: [hv.startTime, hv.endTime]
                            })
                          }
                        }
                        if (timePlanArr.length === 0) {
                          timePlanArr.push(obj)
                        } else {
                          timePlanArr.push(obj)
                        }
                      }
                    })
                  })
                }
              }
            }
            console.log(timePlanArr)
            this.defaultLineIndex = timePlanArr
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 数据整理
      getAttendanceItemDurations(data) {
        this.monDetails = []
        this.tueDetails = []
        this.wedDetails = []
        this.thuDetails = []
        this.friDetails = []
        this.satDetails = []
        this.sunDetails = []
        data.map(v => {
          if (v.weekDay.length > 0) {
            v.weekDay.map(weekDay => {
              if (weekDay === '周一') {
                v.weekTimeValue.map(weekTimeValue => {
                  if (weekTimeValue.key) {
                    if (weekTimeValue.key.length > 0) {
                      let startTime = weekTimeValue.key[0]
                      let endTime = weekTimeValue.key[1]
                      let isInSegments = false
                      this.monDetails.map(segments => {
                        if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                          isInSegments = true
                        }
                      })
                      if (!isInSegments && startTime && endTime) {
                        this.monDetails.push({
                          startTime,
                          endTime
                        })
                      }
                    }
                  }
                })
              }
              if (weekDay === '周二') {
                v.weekTimeValue.map(weekTimeValue => {
                  if (weekTimeValue.key) {
                    if (weekTimeValue.key.length > 0) {
                      let startTime = weekTimeValue.key[0]
                      let endTime = weekTimeValue.key[1]
                      let isInSegments = false
                      this.tueDetails.map(segments => {
                        if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                          isInSegments = true
                        }
                      })
                      if (!isInSegments && startTime && endTime) {
                        this.tueDetails.push({
                          startTime,
                          endTime
                        })
                      }
                    }
                  }
                })
              }
              if (weekDay === '周三') {
                v.weekTimeValue.map(weekTimeValue => {
                  if (weekTimeValue.key) {
                    if (weekTimeValue.key.length > 0) {
                      let startTime = weekTimeValue.key[0]
                      let endTime = weekTimeValue.key[1]
                      let isInSegments = false
                      this.wedDetails.map(segments => {
                        if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                          isInSegments = true
                        }
                      })
                      if (!isInSegments && startTime && endTime) {
                        this.wedDetails.push({
                          startTime,
                          endTime
                        })
                      }
                    }
                  }
                })
              }
              if (weekDay === '周四') {
                v.weekTimeValue.map(weekTimeValue => {
                  if (weekTimeValue.key) {
                    if (weekTimeValue.key.length > 0) {
                      let startTime = weekTimeValue.key[0]
                      let endTime = weekTimeValue.key[1]
                      let isInSegments = false
                      this.thuDetails.map(segments => {
                        if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                          isInSegments = true
                        }
                      })
                      if (!isInSegments && startTime && endTime) {
                        this.thuDetails.push({
                          startTime,
                          endTime
                        })
                      }
                    }
                  }
                })
              }
              if (weekDay === '周五') {
                v.weekTimeValue.map(weekTimeValue => {
                  if (weekTimeValue.key) {
                    if (weekTimeValue.key.length > 0) {
                      let startTime = weekTimeValue.key[0]
                      let endTime = weekTimeValue.key[1]
                      let isInSegments = false
                      this.friDetails.map(segments => {
                        if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                          isInSegments = true
                        }
                      })
                      if (!isInSegments && startTime && endTime) {
                        this.friDetails.push({
                          startTime,
                          endTime
                        })
                      }
                    }
                  }
                })
              }
              if (weekDay === '周六') {
                v.weekTimeValue.map(weekTimeValue => {
                  if (weekTimeValue.key) {
                    if (weekTimeValue.key.length > 0) {
                      let startTime = weekTimeValue.key[0]
                      let endTime = weekTimeValue.key[1]
                      let isInSegments = false
                      this.satDetails.map(segments => {
                        if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                          isInSegments = true
                        }
                      })
                      if (!isInSegments && startTime && endTime) {
                        this.satDetails.push({
                          startTime,
                          endTime
                        })
                      }
                    }
                  }
                })
              }
              if (weekDay === '周日') {
                v.weekTimeValue.map(weekTimeValue => {
                  if (weekTimeValue.key) {
                    if (weekTimeValue.key.length > 0) {
                      let startTime = weekTimeValue.key[0]
                      let endTime = weekTimeValue.key[1]
                      let isInSegments = false
                      this.sunDetails.map(segments => {
                        if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                          isInSegments = true
                        }
                      })
                      if (!isInSegments && startTime && endTime) {
                        this.sunDetails.push({
                          startTime,
                          endTime
                        })
                      }
                    }
                  }
                })
              }
            })
          }
        })
      },

      // 确认添加
      confirm () {
        if (!this.planName) {
          nError('请输入计划名称')
          return false
        }
        let reqData = {
          code: this.code,
          planName: this.planName,
          monDetails: this.monDetails,
          tueDetails: this.tueDetails,
          wedDetails: this.wedDetails,
          thuDetails: this.thuDetails,
          friDetails: this.friDetails,
          satDetails: this.satDetails,
          sunDetails: this.sunDetails,
        }
        api.updateLiftPlan(reqData)
          .then(() => {
            nSuccess('修改成功')
            this.cancel()
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/LadderPlant/LadderPlantModify.vue